import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';
import { EnforcementService, OfficerStatisticsResponse } from 'src/app/Services/enforcement.service';
import { ChartDataResponse } from 'src/app/shared/charts/dashboardchart/ChartResponse';

@Component({
    selector: 'app-officer',
    templateUrl: './officer.component.html',
    styleUrls: ['./officer.component.scss'],
    standalone: false
})
export class OfficerComponent extends ModelEditor {

  public statistics: OfficerStatisticsResponse | null = null;
  public statisticsLoading: boolean = false;

  // Chart configuration for generic-bar-chart
  public chartData: ChartDataResponse | null = null;

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    private injector: Injector,
    private toastr: ToastrService,
    private enforcementService: EnforcementService
  ) {
    super('enforcement/officers', injector);
  }

  public DefaultModel() {
    return {
      UserId: '',
      BadgeNumber: '',
      IsActive: true,
      Notes: ''
    };
  }

  public AfterModelLoaded(): void {
    this.loadStatistics();
  }

  public BeforeSave(): boolean | void {
  }

  public Validators() {
    return {};
  }

  private loadStatistics(): void {
    if (!this.ModelId || this.ModelId === 'new') return;

    this.statisticsLoading = true;
    this.enforcementService.getOfficerStatistics(parseInt(this.ModelId)).then(
      (stats) => {
        this.statistics = stats;
        this.setupChartData();
        this.statisticsLoading = false;
      },
      (error) => {
        console.error('Error loading officer statistics:', error);
        this.statisticsLoading = false;
      }
    );
  }

  private setupChartData(): void {
    if (!this.statistics) return;

    this.chartData = {
      labels: this.statistics.CitationsPerDayLabels,
      stacked: false,
      datasets: [{
        label: 'Citations',
        data: this.statistics.CitationsPerDay,
        displayColor: '#3273dc',
        type: 'bar',
        targetType: 'Citation',
        id: 1
      }]
    };
  }

  public formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }
}


